import { Flex } from '@sequencehq/core-components'
import { FC } from 'react'

import { useAtomValue } from 'jotai'
import { SidebarSection } from 'Cube/view/layouts/quote/QuoteEditorSidebar/widgets/SidebarSection'
import { AnalyticsCard } from '../../../components'
import { TotalViewsCard } from '../TotalViews'
import { getInsightsCaption } from './utils'
import { uniqueViewersCountAtom, viewsByDayAtom } from '../../../atoms'
import { MissingDataWarning } from '../MissingDataWarning'

export const Insights: FC = () => {
  const uniqueViewersCount = useAtomValue(uniqueViewersCountAtom)
  const viewsByDay = useAtomValue(viewsByDayAtom)

  const caption = getInsightsCaption(viewsByDay)

  return (
    <SidebarSection
      title="Insights"
      showBorder
      data-testid="quote.sidebarSection.insights"
    >
      <Flex flexDir="column" marginBottom="16px" gap="8px">
        <AnalyticsCard
          title="Unique viewers"
          value={uniqueViewersCount.toLocaleString('en-US')}
          caption={caption}
          data-testid="quoteAnalytics.uniqueViewers"
        />
        <TotalViewsCard />
        <MissingDataWarning />
      </Flex>
    </SidebarSection>
  )
}
